var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-button-container"},[_c('button',{style:({
      color: _vm.textColor,
      backgroundColor: _vm.backgroundColor,
      border: _vm.borderButton,
      width: _vm.block ? '100%' : '136px',
    }),on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('div',{staticClass:"button-wrapper"},[(_vm.loading)?_c('div',{staticClass:"load"}):_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }